import { cn } from "@/libs/utils";

const LoadingSpinnerWebView = ({ className }: { className?: string }) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M19 3.5625C10.4753 3.5625 3.5625 10.4753 3.5625 19C3.5625 27.5247 10.4753 34.4375 19 34.4375V30.5789C16.7104 30.5786 14.4722 29.8994 12.5686 28.6271C10.6649 27.3549 9.18128 25.5467 8.30522 23.4313C7.42915 21.3159 7.20002 18.9882 7.64678 16.7426C8.09355 14.4969 9.19615 12.4342 10.8152 10.8152C12.4342 9.19615 14.4969 8.09355 16.7426 7.64678C18.9882 7.20002 21.3159 7.42915 23.4313 8.30522C25.5467 9.18128 27.3549 10.6649 28.6271 12.5686C29.8994 14.4722 30.5786 16.7104 30.5789 19H34.4375C34.4375 10.4753 27.5247 3.5625 19 3.5625Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LoadingSpinnerWebView;
